import type { CustomFetchOptions, EmptyResponse } from '@luna/api';
import { request } from '@luna/api';

import { dataToFormData } from './ImageManagementService';

export const AJAX_PARAMS_COMMON: CustomFetchOptions = {
    headers: {
        'Content-Type': null,
    },
};

export const uploadImage = ({
    uploadUrl,
    imageDataUrl,
    data,
    method = 'POST',
}: {
    uploadUrl: string;
    imageDataUrl: string;
    data?: Map<string, string>;
    method?: 'POST' | 'PUT';
}): Promise<EmptyResponse> => {
    return request<EmptyResponse>(uploadUrl, {
        ...AJAX_PARAMS_COMMON,
        body: dataToFormData(imageDataUrl, data),
        method,
    });
};

export const deleteImage = (removeUrl: string): Promise<EmptyResponse> => {
    return request.delete<EmptyResponse>(removeUrl, AJAX_PARAMS_COMMON);
};
